/**
 * @param {import('konva').Stage} stage
 * @param {import('konva').Node | null} node
 * @returns {import('konva').Group | null}
 */
export function closestElementGroup(stage, node) {
  let n = node;
  while (n && n !== stage) {
    if (typeof n.hasName === 'function' && n.hasName('elementGroup')) {
      break;
    }
    n = n.parent;
  }
  if (!n || n === stage) return null;
  while (n.parent && n.parent.getAttr('elementType') === 'group') {
    n = n.parent;
  }
  return n;
}
